import { OrderApiClient } from '@fourthwall/services/dist/OrderApiClient'
import { decodeHtmlEntities } from '@fourthwall/utils/dist/sanitize'
import type { UseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'

export type UseOrdersQueryParams = Parameters<typeof OrderApiClient.getOrders>[0]
export type UseOrdersQueryResponse = Awaited<ReturnType<typeof OrderApiClient.getOrders>>['data']

type UseOrdersQueryKey = Readonly<[string, UseOrdersQueryParams]>
type UseOrdersQueryOptions = UseQueryOptions<
  UseOrdersQueryResponse,
  unknown,
  UseOrdersQueryResponse,
  UseOrdersQueryKey
>

const fetch = async (params: UseOrdersQueryParams) => {
  const { data } = await OrderApiClient.getOrders(params)

  return data
}

export const useOrdersQuery = (params: UseOrdersQueryParams, options?: UseOrdersQueryOptions) => {
  const ordersQuery = useQuery({
    queryKey: ['useOrdersQuery', params],
    queryFn: async () => fetch(params),
    ...options,
    select: (data) => {
      data.orders = data.orders.map((order) => ({
        ...order,
        offers: order.offers.map((offer) => ({
          ...offer,
          offer: { ...offer.offer, name: decodeHtmlEntities(offer.offer.name) },
        })),
      }))

      return data
    },
  })

  return {
    data: ordersQuery.data,
    ordersQuery,
  }
}
